import { render, staticRenderFns } from "./architecture-tab.vue?vue&type=template&id=21b3e5ee&scoped=true"
import script from "./architecture-tab.vue?vue&type=script&lang=js"
export * from "./architecture-tab.vue?vue&type=script&lang=js"
import style0 from "./architecture-tab.vue?vue&type=style&index=0&id=21b3e5ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b3e5ee",
  null
  
)

export default component.exports